import { SocialIntentModule } from "components/modules/SocialIntent";
import React, { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { setCurrentPage } from "store/slices/ui.slice";

export const SocialIntent: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    window.analytics.page("Page Intent");
    dispatch(setCurrentPage('pageIntent'));
  }, []);
  return <SocialIntentModule />
};
